import { Component, OnInit,Input } from '@angular/core';
import { InvestmentService } from '../../services/investment.service';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { PermissionsState } from 'src/app/stores/access-control/access-control.reducers';
import { ConditionalRenderingService } from '../../services/conditional-rendering.service';

@Component({
    selector: 'app-new-investment-checklist',
    templateUrl: './new-investment-checklist.component.html',
    styleUrls: ['./new-investment-checklist.component.scss'],
    standalone: false
})
export class NewInvestmentChecklistComponent implements OnInit {
   @Input() ticker!: string;
   @Input() countryCode!: string;
   @Input() currency: any;
   @Input() status!: string;
   @Input() isSample: boolean = false
   loading2:boolean = false;
   investmentData: any = null;
   isLoggedIn: boolean = false;
   canReadInvestmentChecklist: boolean = false;
   private subscriptions: Subscription[];


  constructor
  (
   private investmentService: InvestmentService,
   private auth: AuthService,
   private permissionStore: Store<{ permissions: PermissionsState }>,
   private conditionalRenderingService: ConditionalRenderingService,
  ) { this.subscriptions = []; }

  ngOnInit(): void {
   //this.fetchData(this.ticker);
   //console.log("currency is",this.currency)

   this.isLoggedIn = this.auth.isLoggedIn();
      this.subscriptions.push(
         this.permissionStore.select(({permissions}) => permissions.permissions).subscribe(
            (permissions) => {
               this.fetchData(this.ticker);
               this.isLoggedIn = this.auth.isLoggedIn();
               this.canReadInvestmentChecklist = permissions.trending_halal_stocks;
            }
         )
      )
  }

  onViewSampleClicked(componentName: string) {
   this.conditionalRenderingService.setComponentType(componentName);
  }

  getSharpeRating(sharpeRatio: number): string {
   if (sharpeRatio < 1) {
     return 'Bad';
   } else if (sharpeRatio >= 1 && sharpeRatio < 2) {
     return 'Good';
   } else if (sharpeRatio >= 2 && sharpeRatio < 3) {
     return 'Very Good';
   } else {
     return 'Excellent';
   }
 }

 getRiskLevelLabel(riskLevel: number): string {
   if (riskLevel >= 0 && riskLevel <= 0.5) {
     return 'Very Low Risk';
   } else if (riskLevel > 0.5 && riskLevel <= 1) {
     return 'Low Risk';
   } else if (riskLevel > 1 && riskLevel <= 1.5) {
     return 'Moderate Risk';
   } else {
     return 'High Risk';
   }
 }

 getScaleIndicator(text: string): 'higher' | 'lower' | 'equal' | 'unknown' {
   if (!text) return 'unknown';
   const lowerText = text.toLowerCase();
   if (lowerText.includes('higher')) return 'higher';
   if (lowerText.includes('lower')) return 'lower';
   if (lowerText.includes('equal')) return 'equal';
   return 'unknown';
 }

 getBackgroundColor(scale: string): string {
   const indicator = this.getScaleIndicator(scale);
   switch (indicator) {
     case 'higher':
       return '#e8f5e9'; // light green
     case 'lower':
       return '#ffebee'; // light red
     case 'equal':
       return '#f5f5f5'; // light gray
     default:
       return '#f5f5f5'; // fallback gray
   }
 }
 getSharpeColor(sharpeRatio: number): string {
   if (sharpeRatio < 1) {
     return '#ffebee'; // light red
   } else if (sharpeRatio >= 1 && sharpeRatio < 2) {
     return '#fffde7'; // light yellow
   } else if (sharpeRatio >= 2 && sharpeRatio < 3) {
     return '#e8f5e9'; // light green
   } else {
     return '#e3f2fd'; // light blue
   }
 }

 getSharpeBackgroundColor(sharpeRatio: number): string {
   if (sharpeRatio < 1) {
     return '#ffeded'; // light red
   } else if (sharpeRatio < 2) {
     return '#fff8e1'; // light yellow
   } else if (sharpeRatio < 3) {
     return '#e8f5e9'; // light green
   } else {
     return '#e3f2fd'; // light blue
   }
 }

 getSharpeTextColor(sharpeRatio: number): string {
   if (sharpeRatio < 1) {
     return '#f44336'; // red
   } else if (sharpeRatio < 2) {
     return '#ff9800'; // amber
   } else if (sharpeRatio < 3) {
     return '#4caf50'; // green
   } else {
     return '#2196f3'; // blue
   }
 }

 getRiskBackgroundColor(riskLevel: number): string {
   if (riskLevel <= 0.5) {
     return '#e8f5e9'; // very low risk → light green
   } else if (riskLevel <= 1) {
     return '#fff8e1'; // low risk → light yellow
   } else if (riskLevel <= 1.5) {
     return '#fff3e0'; // moderate risk → light orange
   } else {
     return '#ffebee'; // high risk → light red
   }
 }

 getRiskIconColor(riskLevel: number): string {
   if (riskLevel <= 0.5) {
     return '#4caf50'; // green
   } else if (riskLevel <= 1) {
     return '#fdc600'; // yellow
   } else if (riskLevel <= 1.5) {
     return '#ff9800'; // orange
   } else {
     return '#f44336'; // red
   }
 }





 hasValidData(): boolean {
   return !!this.investmentData &&
          (this.investmentData.expected_annual_return ||
           this.investmentData.dividendYield ||
           this.investmentData.risk_level ||
           this.investmentData.sharpe_ratio);
 }



  async fetchData(symbol: string) {
   this.loading2 = true; // Start loader
   try {
     this.investmentData = await this.investmentService.getInvestmentChecklist(symbol);
   } catch (error) {
     console.error('Error fetching investment data:', error);
   } finally {
     this.loading2 = false; // Stop loader
   }
 }

}
